// var nroRUC = '';

var respuesta = 'RUC NO VALIDO';
var decimoNum = 0;
var suma = 0;
var mult = 0;
var modulo = 0;
var nroVerificador = 0;
// var nroRuc_chart2 = nroRUC.substring(0,2);
var i = 0; 
var j = 0; 
var x = '';
var numero = 0;


const validationRuc = (nroRUC, msg) => {
  if(nroRUC.length === 13) {
    // if(nroRuc_chart2 === '10' || nroRuc_chart2 === '15' || nroRuc_chart2 === '16' || nroRuc_chart2 === '17' || nroRuc_chart2 === '20'){   //Validar esto!!
      if(nroRUC.charAt(2) == '9'){
      j = 4;  
      }else if(nroRUC.charAt(2) == '6'){
        j = 3;
      }
      while(j > 1){
        x = nroRUC.charAt(i);
        numero = parseInt(x);
        mult = numero * j;
        suma += mult;
        i++;
        j--;
      }

      j = 7;
      while(j > 1){
        x = nroRUC.charAt(i);
        numero = parseInt(x);
        mult = numero * j;
        suma += mult;
        i++;
        j--;
      }
      
      modulo = suma % 11;
      nroVerificador = 11 - modulo;
      decimoNum = nroRUC.charAt(2) == '9' ? parseInt(nroRUC.charAt(9)) : parseInt(nroRUC.charAt(8));

      if(nroVerificador === decimoNum){
        respuesta = msg;
        return true;
      }
    // }
  }
  return false; 
}

const warningAlert = (title, description) => {
  return window.Swal.fire(title, description, 'warning');
}

const successAlert = (title, description)  => {
  return window.Swal.fire(title, description, 'success');
}

const loadingAlert = (title, content) => {
  return window.Swal.fire({
      title,
      html: content,
      timerProgressBar: true,
      onBeforeOpen: () => {
          window.Swal.showLoading()
      },
      allowOutsideClick: () => !window.Swal.isLoading(),
  })
}

export default {validationRuc, warningAlert, successAlert, loadingAlert}